<!--
* @Author : ShaJiaJing
* @Date :  2023/6/19
* @Version : 1.0
* @Content : $END$
* @update 2023-06-19 13:54
-->
<template>
  <a-modal
    :title="$t(`${LANG_PREFIX}.title`)"
    :visible="visible"
    :maskClosable="false"
    @ok="onClose"
    @cancel="onClose"
  >
    <h5 v-text="$t(`${LANG_PREFIX}.content[0]`)" />
    <i18n :path="`${LANG_PREFIX}.content[${item}]`" v-for="item in 7" :key="item" :class="{ 'last': [6, 7].includes(item) }" tag="p">
      <a place="phone" href="javascript:;">400-8218-738</a>
      <a place="link" href="https://rpa.i-search.com.cn/store/tryNow">https://rpa.i-search.com.cn/store/tryNow</a>
    </i18n>

    <template slot="footer">
      <a-button type="primary" @click="onClose">{{ $t(`${LANG_PREFIX}.action.ok`) }}</a-button>
    </template>
  </a-modal>
</template>

<script>
const LANG_PREFIX = 'notice.widtdrawal'
export default {
  components: {},
  data () {
    return {
      LANG_PREFIX,
      visible: false,
      record: {}
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {
    onShow (record) {
      this.record = record
      this.visible = false
    },
    onClose (refresh) {
      this.visible = false
      localStorage.setItem('noticeWithdraw', true)
      if (refresh === true) this.$emit('ok')
    }
  }
}
</script>

<style lang="less" scoped>
h5{
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
  font-size: 14px;
}
p:not([class=last]){
  color: #666;
  line-height: 24px;
  text-indent: 2em;
}
</style>
